import React from 'react';
type SectionHeadingProps = {
  kicker?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
};
export function SectionHeading({
  kicker,
  title,
  subtitle
}: SectionHeadingProps) {
  return <div className="mx-auto mb-10 max-w-3xl text-center" data-id="element-293" data-mp="3f1vnlllt2lh3">
      {kicker && <p className="mb-3 font-display text-lg font-bold uppercase tracking-wider text-amber" data-id="element-294" data-mp="3jzx35wk0w2nt">{kicker}</p>}
      <h2 className="font-display text-4xl font-extrabold uppercase leading-[1.02] text-white sm:text-5xl" data-id="element-295" data-mp="bk3nfjximv7t">
        {title}
      </h2>
      {subtitle && <p className="mt-4 text-lg leading-relaxed text-mist" data-id="element-296" data-mp="giosbwnpq32l">{subtitle}</p>}
    </div>;
}